import { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { LuChevronLeft, LuPlus } from "react-icons/lu";

import { ModalBtn } from '../modals/ModalBtn';
import { GGNLocations } from '../../interfaces/intakes.reports';
import { useGGNLocations } from '../../api/useWeatherGGN';
import { GGNLocation } from './GGNLocation';
import { useWeather } from '../../hooks/useWeather';
import { City } from '../../interfaces/weather.types';
import { GGNWeather } from './GGNWeather';
import { useQueryClient } from '@tanstack/react-query';

interface Props {
    closeModal: () => void
    reportId: string
    weather: GGNLocations[]
    mainData_loading_date: Date
    isEdit?: boolean
}

export const ModalGGNLocations = ({ closeModal, reportId, weather, mainData_loading_date, isEdit }: Props) => {

    const initialLocation: GGNLocations = {
        city: '', country: '', coords: {
            lat: 0,
            lon: 0
        }, quantity: 0, ggn_number: '', harvest_day: mainData_loading_date
    }

    const { mutate, isLoading } = useGGNLocations()
    const [new_ggn, setNew_ggn] = useState<GGNLocations>(initialLocation)
    const [steps, setSteps] = useState<number>(1)
    const { loading: isLoadingWeather, fetchWeatherData } = useWeather()
    const queryClient = useQueryClient()

    useEffect(() => {
        if (isEdit) return setSteps(2)
        if (weather.length > 0) {
            setSteps(1)
        } else {
            setSteps(2)
        }
    }, [weather])


    const sendGGNLocations = async () => {

        const newCity: City = {
            city: new_ggn.city,
            country: new_ggn.country,
            latitude: new_ggn.coords.lat,
            longitude: new_ggn.coords.lon,
            date: new_ggn.harvest_day
        }

        if (weather.find(loc => loc.city === newCity.city)) { return toast.error(`${newCity.city} already exists`) }
        if (newCity.city.trim() === '') { return toast.error("Please fill in the Location name") }
        if (newCity.country.trim() === '') { return toast.error("Please fill in the Country") }

        if (newCity.latitude === 0 || newCity.longitude === 0) { return toast.error("Please fill in the coordinates for all locations") }

        const data = await fetchWeatherData([newCity])
        if (!data || data.length === 0) { return toast.error("Error fetching weather data") }

        const ggnLocation: GGNLocations = {
            harvest_day: newCity.date || mainData_loading_date,
            ggn_number: new_ggn.ggn_number || '',
            city: newCity.city.trim(),
            country: newCity.country.trim() || '',
            quantity: new_ggn.quantity || 0,
            coords: { lat: newCity.latitude, lon: newCity.longitude },
            historical: data.find(d => d.city === newCity.city)?.historical || []
        }

        mutate({
            reportId,
            ggnLocations: [...weather, ggnLocation]
        }, {
            onSuccess: async() => {
                toast.success("GGN Locations updated")
                setSteps(1)
                setNew_ggn(initialLocation)

                if (isEdit) {
                    await queryClient.invalidateQueries(['reportTemp', reportId])
                    closeModal()
                }
            }
        })
    };

    const handleLocationValue = (location: GGNLocations) => {
        setNew_ggn(location);
    };

    const loading = isLoading || isLoadingWeather

    return (
        <div className="modal">

            <div className="modal__card tw-max-w-[600px]">

                <div className="modal__content">

                    <div className='tw-flex tw-justify-between tw-items-center tw-mb-3'>
                        <h3>GGN Locations</h3>
                        {
                            weather?.length > 0 &&
                            <button
                                className='tw-flex tw-justify-center tw-items-center tw-w-8 tw-rounded-xl tw-aspect-square tw-bg-blue-600'
                                onClick={() => { steps === 1 ? setSteps(2) : setSteps(1) }}
                            >
                                {
                                    steps === 1
                                        ? <LuPlus size={20} color='white' />
                                        : <LuChevronLeft size={20} color='white' />
                                }
                            </button>
                        }
                    </div>

                    {
                        steps === 1
                            ? <GGNWeather weather={weather} closeModal={() => closeModal()} reportId={reportId} />
                            : <>
                                <GGNLocation location={new_ggn} handleLocationValue={handleLocationValue} />

                                <ModalBtn
                                    action={sendGGNLocations}
                                    closeModal={() => closeModal()}
                                    isLoading={loading}
                                // disabled={new_ggn.length === 0}
                                />
                            </>
                    }

                </div>
            </div>

        </div>
    )
}